export default __webpack_public_path__ + "static/media/56.320fe263.png";